import axios from "axios";
var APPLICATION_ID = "vLTJ6cMbW0UuB8Bs4zZ4",
  APPLICATION_CODE = "V1IB61yi2tiljthIgdLW3g";
var app_key = "2O69_Lcwqq8kL5ez9IVLTyLIeihshlO2RqJ73lUMd74";
export function getAppKey() {
  return {
    APPLICATION_ID: "vLTJ6cMbW0UuB8Bs4zZ4",
    APPLICATION_CODE: "V1IB61yi2tiljthIgdLW3g",
    app_key: "2O69_Lcwqq8kL5ez9IVLTyLIeihshlO2RqJ73lUMd74"
  };
}

export function getPlatform(H) {
  var platform = new H.service.Platform({
    app_id: APPLICATION_ID,
    app_code: APPLICATION_CODE,
    apikey: app_key,
    useCIT: false,
    useHTTPS: true
  });
  return platform;
}
// var geocoder = platform.getGeocodingService();

/**
 * Removes all H.map.Marker points from the map and adds closes the info bubble
 */
// var curTruckHeight = 10;

export function getTimeZone(position, callback) {
  var par =
    "prox=" +
    position[0] +
    "," +
    position[1] +
    "&mode=retrieveAddresses&maxresults=1&locationattributes=adminInfo,timeZone";
  var url =
    "https://reverse.geocoder.cit.api.here.com/6.2/reversegeocode.json?" +
    par +
    "&app_id=" +
    APPLICATION_ID +
    "&app_code=" +
    APPLICATION_CODE;
  fetch(url)
    .then(res => res.json())
    .then(res => {
      // console.log(res);
      //   res = res.json();
      var results = res;

      callback(results);
    });
}

export async function getRoute(waypoints, options) {
  var routingParameters = {
    mode: "balanced;truck",
    traffic: "enabled",

    // "routeattributes ": "waypoints,summary",
    linkAttributes: "truckRestrictions",
    maneuverattributes: "direction,action",
    legattributes: "length,travelTime,links",
    // height: options.truckHeight || h + "m",
    // commercial: "1",
    tollVehicleType: "3",
    vehicleNumberAxles: "2",
    // tiresCount: "4",
    // currency: options.currency || "USD",
    departure: options.departure || "now",
    representation: "display"
    // rollup: "none",
    //'cost_optimize':'1',
    // detail: "0",
  };

  // "imperial" : "metric";
  if (options) {
    Object.keys(options).forEach(k => {
      routingParameters[k] = options[k];
    });
  }

  waypoints.forEach(function (w, i) {
    routingParameters["waypoint" + i] = w; // coord.latitude + "," + coord.longitude;
  });

  var par = "";
  Object.keys(routingParameters).forEach(function (k) {
    par += k + "=" + routingParameters[k] + "&";
  });
  var host = "https://route.ls.hereapi.com/routing/7.2/"; //https://tce.api.here.com/2/
  var url = host + "calculateroute.json?" + par + "&apiKey=" + app_key;
  var data = await axios.get(url);
  return data.data.response;
}

export async function calculateRoute(waypoints, service, departure) {
  if (waypoints.length >= 2) {
    var distanceOptions = {
      metricSystem: "imperial",
      departure: departure
    };
    var res = await this.getRoute(waypoints, distanceOptions);
    // , function(res) {
    var route = res.route[0];

    var distance = 0;
    var travelTime = 0;
    route.leg.forEach(l => {
      distance += l.length;
      travelTime += l.travelTime;
    });
    // model.distance = distance;
    // model.mileage = (distance / 1.6 / 1000).toFixed(2);
    // model.driving_time = (travelTime / 3600).toFixed(2);
    // service.route = route;
    // fn(route);
    // });
  } else {
    route = { waypoints: waypoints };
    // service.route = route;
  }
  return route;
}
export function getMoveType(origin, destination, mileage, defaultSettings) {
  // var origin, destination;
  // if (service.shipment_stop && service.shipment_stop.length > 1) {
  //   origin = service.shipment_stop[0].location;
  //   destination =
  //     service.shipment_stop[service.shipment_stop.length - 1].location;
  // }

  // var defaultSettings = this.data_object.company.default_settings;
  if (origin && destination && origin.address && destination.address) {
    if (
      defaultSettings.local_states &&
      destination.address.geo &&
      origin.address.geo &&
      destination.address.geo.location.address.stateCode &&
      origin.address.geo.location.address.stateCode &&
      defaultSettings.local_states.includes(
        destination.address.geo.location.address.stateCode.toLowerCase()
      ) &&
      defaultSettings.local_states.includes(
        origin.address.geo.location.address.stateCode.toLowerCase()
      )
    ) {
      var newMoveType = "";
      if (parseFloat(mileage) <= parseFloat(defaultSettings.radius)) {
        newMoveType = "local";
      } else {
        newMoveType = "short_haul";
      }
    } else {
      newMoveType = "long_distance";
    }

    return newMoveType;
  }
}
export async function getGeoCode(address) {
  var url =
    "https://geocoder.ls.hereapi.com/6.2/geocode.json?apiKey=" +
    getAppKey().app_key +
    "&searchtext=" +
    address;
  // this.platform = getPlatform(window.H);
  // var service = this.platform.getSearchService();
  // var geoCode = await service.geocode({
  //   q: address,
  // });

  var data = await axios.get(url);
  return data.Response;
}

export function getCoordinates() {
  var coordinates = localStorage.getItem("coordinates");
  if (!coordinates) {
    var curPosition = localStorage.getItem("curPosition");
    if (curPosition) {
      curPosition = JSON.parse(curPosition);
      coordinates =
        curPosition.coords.latitude + "," + curPosition.coords.longitude;

      localStorage.setItem("coordinates", coordinates);
    }
  }
  return coordinates;
}
export function calcCrow(p1, p2) {
  var R = 6371; // km
  var dLat = toRad(p2.lat - p1.lat);
  var dLon = toRad(p2.lng - p2.lng);
  var lat1 = toRad(p1.lat);
  var lat2 = toRad(p2.lat);

  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c;
  return d;
}

// Converts numeric degrees to radians
export function toRad(Value) {
  return (Value * Math.PI) / 180;
}
export function findCenter(markers) {
  let lat = 0;
  let lng = 0;

  for (let i = 0; i < markers.length; ++i) {
    lat += parseFloat(markers[i].lat);
    lng += parseFloat(markers[i].lng);
  }

  lat /= markers.length;
  lng /= markers.length;

  return { lat: lat, lng: lng };
}
// export function Point(x, y) {
//   this.x = x;
//   this.y = y;
// }

// export function Region(points) {
//   this.points = points || [];
//   this.length = points.length;
// }

// Region.prototype.area = function () {
//   var area = 0,
//       i,
//       j,
//       point1,
//       point2;

//   for (i = 0, j = this.length - 1; i < this.length; j=i,i++) {
//       point1 = this.points[i];
//       point2 = this.points[j];
//       area += point1.x * point2.y;
//       area -= point1.y * point2.x;
//   }
//   area /= 2;

//   return area;
// };

// Region.prototype.centroid = function () {
//   var x = 0,
//       y = 0,
//       i,
//       j,
//       f,
//       point1,
//       point2;

//   for (i = 0, j = this.length - 1; i < this.length; j=i,i++) {
//       point1 = this.points[i];
//       point2 = this.points[j];
//       f = point1.x * point2.y - point2.x * point1.y;
//       x += (point1.x + point2.x) * f;
//       y += (point1.y + point2.y) * f;
//   }

//   f = this.area() * 6;

//   return new Point(x / f, y / f);
// };
// function clearHtml(html) {
//   return $("<div/>")
//     .html(html)
//     .text()
//     .trim();
// }
// export function getFullAddress(address, fn) {
//   var geocodingParameters = {
//     searchText: address.replace(/,/g, ""),
//     jsonattributes: 1,
//   };

//   geocoder.geocode(
//     geocodingParameters,
//     function(result) {
//       try {
//         var location = result.response.view[0].result[0].location;
//         var lat, lng, addr;
//         //for (i = 0; i < locations.length; i++) {

//         lat = location.displayPosition.latitude;
//         lng = location.displayPosition.longitude;
//         addr = location.address;

//         //}

//         var street = "";

//         if (addr.houseNumber && addr.street) {
//           street = clearHtml(addr.houseNumber + " " + addr.street) + " ";
//         }

//         var fullAddress = {
//           street: street.trim(),
//           city: clearHtml(addr.city),
//           state: clearHtml(addr.state),
//           zip: addr.postalCode,
//           country: addr.country,
//           lat: lat,
//           lng: lng,
//         };
//         console.log(fullAddress);

//         if (fn) {
//           fn(fullAddress);
//         }
//       } catch (e) {
//         if (fn) {
//           fn(address);
//         }
//       }
//     },
//     function() {}
//   );
// }
